import { Dialog } from "@mui/material";
import { useScale, btnDelay, usePlaySound } from "common/utils";
import { ParentCloseBtn, FadeTransition } from "common/elements";
import i18n from "features/parent/i18n";
import { ParentPieceComment } from "features/parent/types";
import { ParentPieceCommentRow } from "./ParentPieceCommentRow";

export const PieceCommentListModal = ({
  comments,
  onClose,
  onSelectComment,
}: {
  comments: ParentPieceComment[];
  onClose: () => void;
  onSelectComment: (comment: ParentPieceComment) => void;
}) => {
  const play = usePlaySound();
  const { scale } = useScale();

  return (
    <Dialog
      fullScreen
      open={true}
      maxWidth={false}
      sx={{ zIndex: 99999 }}
      TransitionComponent={FadeTransition}
      PaperProps={{ style: { backgroundColor: "transparent" } }}
    >
      <div className="flex-col-center w-full h-full bg-textcolor-black/50">
        <div style={{ transform: `scale(${scale})` }}>
          <div className="flex-col-el w-[800px] h-[700px] border-solid border-gray2-30 border-[16px] rounded-[16px] bg-gray2-30">
            <div className="flex-col-el justify-start w-full h-full relative p-6 rounded-[8px] bg-white overflow-hidden">
              <ParentCloseBtn close={onClose} />
              <div className="flex-row-el items-center gap-2 mb-4 pb-3 border-b border-outline shrink-0">
                <span className="material-symbols-outlined !text-[54px] text-red-100">
                  chat_bubble
                </span>
                <h2 className="text-[33px] text-textcolor-black">
                  {i18n.t("MSG_PARENT_PAGE_PLAYER_PIECE_COMMENTS")}
                </h2>
                <span className="text-[24px] text-gray2-100 ml-1">({comments.length})</span>
              </div>

              <div className="flex-1 overflow-y-auto invisible-scrollbar min-h-0">
                <div className="flex-col-el gap-3">
                  {comments.map((comment) => (
                    <ParentPieceCommentRow
                      key={comment.id}
                      comment={comment}
                      onClick={() => {
                        play();
                        btnDelay(() => onSelectComment(comment));
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
